import isArray from 'lodash/isArray';

import { updateDatasheet } from 'common/api/datasheets';

import {
    UPLOAD_DATASHEET,
    UPLOAD_DATASHEET_FAILURE,
    UPLOAD_DATASHEET_SUCCESS,
} from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

import showForm from './showForm';

export default (values, productId) => (dispatch) =>
    new Promise((resolve) => {
        var data = new FormData();
        data.append('data_sheet_name', values.datasheet_name);

        if (isArray(values.datasheet_archive)) {
            data.append(
                'data_sheet',
                values.datasheet_archive && values.datasheet_archive[0],
            );
        }

        dispatch(productDatasheetsActions[UPLOAD_DATASHEET]());

        updateDatasheet(data, productId)
            .then((response) => {
                dispatch(
                    productDatasheetsActions[UPLOAD_DATASHEET_SUCCESS](
                        response.data,
                    ),
                );
                dispatch(showForm(false));
            })
            .catch((error) =>
                dispatch(
                    productDatasheetsActions[UPLOAD_DATASHEET_FAILURE](
                        error.response.data.errors,
                    ),
                ),
            )
            .finally(resolve);
    });
